import PlansPage from "@/pages/support/PlansPage";

/**
 * Financial-side plans manager.
 * Uses the new /plans endpoint (RBAC: read=any, write=full_admin only).
 * Support sees the same page in read-only mode at /support/plans.
 */
export default function PlanesFinanciero() {
  return <PlansPage apiBase="/plans" section="Financial" page="Planes y tarifas" />;
}
